<script>
import appConfig from "@/app.config";
import {
  layoutMethods,
  reportsMethods,
  reportsComputed,
} from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Sell E-Load Transaction Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      transactionId: "",
      transDetails: {
        id: 0,
        userId: 0,
        transactionId: "--",
        costAmount: 0,
        transactionAmount: 0,
        margin: 0,
        customerInfo: {
          userId: 0,
          businessId: 0,
          name: "--",
          businessName: "--",
          mobile: "--",
          email: "--",
          address: "--",
        },
        address: "--",
        promoCode: "--",
        transactionStatus: "--",
        errorDescription: "--"
      },
      searchValue: {
        searchField: null,
        search: "",
        status: null,
        dateRange: null,
        payment_method: null,
        sort: "id",
        orderDesc: true,
      },
      params: {},
      statusOption:[
        {"value": null,"text":"Select Transaction Status", disabled:true},
        {"value":"PENDING","text":"Pending"},
        {"value":"SUCCESS","text":"Success"},
        {"value":"FAILED","text":"Failed"},
      ],
      selectedEloadStatus: null,
      isSubmitted:false,
      isRefundAmount: true,
      radioRefund: null,
      refundReason: null,
      updateStatusValidation: {
        errorDescription: false,
      },
    };
  },
  mounted: async function () {
    this.transactionId = this.$route.params.id;
    this.changeTitle({ title: "Sell E-Load Transaction Details" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Report", to: { name: "Report" } },
        { text: "Sell E-Load Transaction", to: { name: "Eload Transaction" } },
        { text: this.transactionId, to: { name: "Transation ID" } },
      ],
    });
    await this.getEloadLogById();
    this.radioRefund = "yes";
  },
  computed: {
    ...reportsComputed,
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    /*
      Created by: Jero Balucas
      Created at: Nov 21, 2022
      Description: getEloadLogById will fetch the eload transaction details by transaction id
      Params: this.transactionId
    */
    getEloadLogById: async function () {
      // this.searchValue.search = this.transactionId;
      await this.getEloadTransactionDetails({
        "transactionId":this.transactionId
      });
      this.transDetails = this.eloadLogs[0];
      this.selectedEloadStatus = this.transDetails.transactionStatus;
    },
    /*
      Description: getStatusTransClassColor will set the text color based on status
      Params: data = this.transView.data.status
    */
    getStatusClassColorTrans(data) {
      return data === 'FAILED' ? 'text-danger' : data === 'SUCCESS' ? 'text-success' : 'text-warning'; 
    },
    updateEloadStatus(pStatus) {
      let status = pStatus;

      if (status == "PENDING") {
        return;
      }

      Swal.fire({
          title: "Change E-Load Status to " + (status == "SUCCESS" ? "Success" : "Failed"),
          text: `Are you sure you want to proceed?`,
          icon: "question",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Yes",
      }).then(async (result) => {
          if (result.isConfirmed) {
            if (status == "FAILED") {
              this.openModal('bv-modal-update-eload-status');
            }
            else if (status == "SUCCESS") {
              // API call for changing the eload status
              await this.updateEloadTransactionStatus({
                  transactionId: this.transactionId,
                  status: "SUCCESS",
                  isForRefund: false,
                  refundReason: null
              }).then(() => {
                  Swal.fire(
                      "Update Successful!",
                      `E-Load status has been updated.`,
                      "success"
                  ).then(async() => {
                      await this.getEloadLogById();
                  });

              }).catch((err) => {
                  console.error("Error while updating transaction status: ", err);
                  this.selectedEloadStatus = 'PENDING';

                  Swal.fire(
                      "Update Failed!",
                      `E-Load Transaction was not updated.`,
                      "error"
                  );
              })

            }
          }
          else {
            this.selectedEloadStatus = 'PENDING';
          }
      });

    },
    async updateFailedEload(){
      this.closeModal('bv-modal-update-eload-status');

      // API call for changing the eload status
      await this.updateEloadTransactionStatus({
          transactionId: this.transactionId,
          status: "FAILED",
          isForRefund: this.radioRefund == "yes" ? true : false,
          refundReason: this.refundReason
      }).then(() => {
          Swal.fire(
              "Update Successful!",
              `E-Load status has been updated.`,
              "success"
          ).then(async() => {
              await this.getEloadLogById();
              this.resetModal("bv-modal-update-eload-status");
          });
          
      }).catch((err) => {
          console.error("Error while updating transaction status: ", err);
          this.resetModal("bv-modal-update-eload-status");

          Swal.fire(
              "Update Failed!",
              `E-Load Transaction was not updated.`,
              "error"
          );
      })
    },
    openModal(modal=''){
        this.$bvModal.show(modal);
    },
    closeModal(modal=''){
        this.$bvModal.hide(modal);
    },
    resetModal(modal='') {
      if (modal == "bv-modal-update-eload-status") {
        this.selectedEloadStatus = this.transDetails.transactionStatus; 
        this.isSubmitted = false;
        this.refundReason = null;
        this.radioRefund = "yes";
      }
    },
    checkForm() {
        this.updateStatusValidation.errorDescription = false;
        let isValidationPassed = true;

        if(this.isEmpty(this.refundReason) == true && this.radioRefund == 'yes') {
          isValidationPassed = false;
          this.updateStatusValidation.errorDescription = true;
        }

        if (isValidationPassed) {
          this.isSubmitted = true;
          this.updateFailedEload();
        }
    },
    isEmpty(value) {
        return (
            // null or undefined
            (typeof value == "undefined") || 
            (value == undefined) || 
            (value == null) || 
            (value === "") || 

            // has length and it's zero
            (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) || 

            // is an Object and has no keys
            (value.constructor === Object && Object.keys(value).length === 0)
        );
    },
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xl-3">
        <!-- Merchant Details card -->
        <div class="card">
          <div class="card-body">
            <div class="d-flex mb-3 border-bottom pb-2 text-dark">
              <div class="flex-grow-1 my-auto">
                <span class="align-middle fw-semibold">Merchant Details</span>
              </div>
            </div>
            <ul class="list-unstyled mb-0 mt-4">
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-user-circle"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Name</p>
                    <h5 class="mb-0 font-size-14 fw-normal">
                      {{ transDetails.customerInfo.name }}
                    </h5>
                  </div>
                </div>
              </li>
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-mobile-alt"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Mobile Number</p>
                    <h5 class="mb-0 font-size-14 fw-normal">
                      {{ transDetails.customerInfo.mobile }}
                    </h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-envelope"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Email</p>
                    <h5 class="mb-0 font-size-14 fw-normal">
                      {{ transDetails.customerInfo.email }}
                    </h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-receipt"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Business Name</p>
                    <h5 class="mb-0 font-size-14 fw-normal">
                      {{ transDetails.customerInfo.businessName }}
                    </h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
            </ul>
          </div>
        </div>
        <!-- end Merchant Details card -->
      </div>
      <!-- end col -->

      <div class="col-xl-9">
        <div class="row">
          <div class="col-lg-12">
            <!-- Transaction Details card -->
            <div class="card">
              <div class="card-body">
                <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                  <div class="flex-grow-1 my-auto">
                    <span class="align-middle fw-semibold"
                      >Transaction Details</span
                    >
                  </div>
                </div>
                <div class="row">
                  <form>
                    <div class="row">
                      <div class="col-lg-8">
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Address:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                              {{ transDetails.address }}
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">
                                Promo Code:
                            </p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                              {{ transDetails.promoCode }}
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Request Date:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                                {{ transDetails.requestTimeStamp | formatDate }}
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">
                                Transaction ID:
                            </p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                                {{ transDetails.transactionId }}
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Transaction Status:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                                <span :class="getStatusClassColorTrans(transDetails.transactionStatus)">{{ transDetails.transactionStatus }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">
                                Error Description:
                            </p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                              {{ transDetails.errorDescription }}
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">
                                Transaction Amount:
                            </p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                              PHP {{ transDetails.transactionAmount.toFixed(2) }}
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Cost Amount:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                              PHP {{ transDetails.costAmount.toFixed(2) }}
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Margin:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                              PHP {{ transDetails.margin.toFixed(2) }}
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">EPin:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                              {{ transDetails.epin == null ? "-":transDetails.epin }}
                            </p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Provider:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">
                              {{ transDetails?.providerName | notEmpty }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2" v-if="transDetails.transactionStatus == 'PENDING'"></div>
                      <div class="col-lg-2" v-if="transDetails.transactionStatus == 'PENDING'">
                        <label class="form-label small">Change Status</label>
                        <b-form-select
                          class="form-control w-75 border"
                          placeholder="Select Status here"
                          v-model="selectedEloadStatus" 
                          :options="statusOption"
                          :class="{
                              'border-success': selectedEloadStatus == 'SUCCESS',
                              'border-danger': selectedEloadStatus == 'FAILED',
                              'border-warning': selectedEloadStatus == 'PENDING',
                          }"
                          @change="updateEloadStatus(selectedEloadStatus)"
                        />
                      </div>
                    </div>
                    <!-- hidden -->
                  </form>
                </div>
              </div>
            </div>
            <!-- end card -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->


    <!-- Modal -->
    <b-modal id="bv-modal-update-eload-status"
      size="md"
      centered
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
    >
        <div class="col-md-12 text-center">
            <i class="mdi mdi-alert-circle-outline update-status-icon-custom text-secondary"></i>
            <p class="form-label large fw-bold" style="font-size: 1.5em; margin: -7px 0 18px 0;">Failed Transaction</p>
          <!-- <p class="form-label mt-2 mb-3 px-5">Provide Reason:</p> -->
        </div>

        <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form @submit.prevent="handleSubmit(checkForm())"
                    @reset.prevent="reset">
                    
              <div class="cold-md-12 mb-3 mx-3">
                <label class="form-label">Refund the amount Php {{ transDetails.transactionAmount.toFixed(2) }}?</label>
                <div class="form-check mb-2">
                  <input class="form-check-input"
                        type="radio"
                        name="formRadios"
                        id="formRadioYes" 
                        v-on:change="isRefundAmount = true"
                        v-model="radioRefund"
                        value="yes"
                        checked
                  />
                  <label class="form-check-label" for="formRadioYes">
                    Yes
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input"
                        type="radio"
                        name="formRadios"
                        id="formRadiosNo" 
                        v-on:change="isRefundAmount = false"
                        v-model="radioRefund"
                        value="no"
                  />
                  <label class="form-check-label" for="formRadiosNo">
                    No
                  </label>
                </div>

                <div class="col-md-12 mt-3" v-if="radioRefund == 'yes'"> <!-- Start of refund reason field -->
                  <label>Error Description<span class="text-danger">*</span></label>
                  <b-form-input placeholder="Enter Refund Reason"
                                v-model="refundReason"
                                class="form-control"
                                :class="{
                                    'is-invalid' : updateStatusValidation.errorDescription
                                }"
                                trim
                  ></b-form-input>
                  <div v-if="updateStatusValidation.errorDescription"
                       class="invalid-feedback">
                       This field is required
                  </div>
                </div> <!-- End of refund reason field -->
              </div>

              <!-- Modal action buttons -->
              <div class="text-end mt-3 px-1">
                <b-button variant="light"
                          class="w-sm me-3"
                          @click="closeModal('bv-modal-update-eload-status');
                                  resetModal('bv-modal-update-eload-status')">
                    Cancel 
                </b-button>
                <b-button type="submit"
                          variant="primary"
                          :disabled="isSubmitted">
                    <span v-if="isSubmitted"
                          class="spinner-grow spinner-grow-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                    Save
                </b-button>
              </div>
          </b-form>
        </ValidationObserver>
        
    </b-modal><!--bv-modal-update-eload-status-->
  </div>
</template>


<style>
  .update-status-icon-custom {
    font-size: 7em;
  }
</style>
